/**
 *
 */
export const LAST_AI_PLUS_SCRIPT_CACHE_KEY = 'last-ai-plus-script'
